export { TinyProvider as default, Context } from './TinyProvider'
